import isHotKey from 'is-hotkey';
import toggleSelectedTodos from '../utils/toggleSelectedTodos';
import isTodoBlock from '../utils/isTodoBlock';
export default function onKeyDown(event, editor, next) {
  if (editor.value.selection.isUnset) return next();
  if (!isTodoBlock(editor.value)) return next();

  if (isHotKey('mod+enter', event)) {
    event.preventDefault();
    return toggleSelectedTodos(editor);
  }

  if (isHotKey('enter', event) && !editor.query('isEmptyBlock')) {
    event.preventDefault();
    editor.command('removeCurrentMarks');
    return toggleSelectedTodos(editor.splitBlock(), false);
  }

  return next();
}